// extracted by mini-css-extract-plugin
export default {"skeleton_field":"style_skeleton_field__Zu37-"};